import "./career.css";
import { Container, Header } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../store/store";
import { setActiveMenuItem } from "../../store/reducer";

const Career = () => {
    const navigate = useNavigate();
    const [, dispatch] = useStore();

    const handleContactClick = (event) => {
        event.preventDefault();
        dispatch(setActiveMenuItem('/contact'));
        navigate('/contact');
    };

    return (
        <Container className="career">
            <Header as='h3' content='Join Our Team' className='career-h3' textAlign='center' />
            <div className="career-content">
                <p className="career-description">
                    If you're passionate about innovation in ventilation industrial systems and believe you have what it takes to make a difference, we'd love to hear from you.
                </p>
                <p className="career-description">
                    Please send your CV to any of the listed email addresses on our <a href="/contact" onClick={handleContactClick}>Contact Us</a> page.
                </p>
            </div>
        </Container>
    );
};

export default Career;
